import React from 'react';
import Career from '../components/Background/Career';
import Education from '../components/Background/Education';
// import Contributions from '../components/Background/Contributions';


const Background = () => {
    return (
        <div id="background" className="p-4">
            <div id="background-header" className="text-4xl">
                <h1 className="text-3xl font-bold mb-4">Background</h1>
                <hr className="border-t-2 border-gray-300 mb-1" /> {/* Horizontal line */}
            </div>
                
            <div id="education" className="mt-8">
                <Education />
            </div>
            <div id="career" className="mt-8"> {/* Apply margin-top for spacing */}
                <Career />
            </div>
            {/* <div id="contribution" className='mt-8'>
                <Contributions/>
            </div> */}
        </div>
    );
}

export default Background;
